import { APP_DATE_FORMAT_MID } from "@/config/constants";
import { IEdoQuizAttempt } from "@/shared/model/edo-quiz-attempt.model";
import { getQuizAttemptStatus } from "@/shared/util/quiz-utils";
import { ListItem, ListItemText } from "@/components/ui";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { TextFormat } from "react-jhipster";
import { useNavigate } from "react-router-dom";

interface UserAttemptRowProps {
    quizAttempt: IEdoQuizAttempt;
    onOpen: (quizAttempt: IEdoQuizAttempt) => void;
}

const UserAttemptRow = (props: UserAttemptRowProps) => {
    const navigate = useNavigate();
    const [score, setScore] = useState<{ score: number; totalScore: number }>({ score: 0, totalScore: 0 });

    const { quizAttempt, onOpen: handleOpen } = props;

    const getQuizAttemptScore = async () => {
        const response = await axios.get<{ data: { score: number; totalScore: number } }>(
            `/quiz-attempts/${quizAttempt?.id}/score`
        );
        setScore(response.data.data);
    };

    useEffect(() => {
        if (quizAttempt?.id) {
            getQuizAttemptScore();
        }
    }, [quizAttempt?.id]);

    const attemptStatus = useMemo(
        () => getQuizAttemptStatus(quizAttempt, score.score, score.totalScore),
        [quizAttempt, score.score, score.totalScore]
    );

    const isExpired = new Date(quizAttempt.timeFinish).getTime() < Date.now();

    return (
        <ListItem
            className={`flex cursor-pointer items-center gap-3 rounded-2xl px-3 py-2.5 transition-all duration-200 hover:bg-primary/10 ${
                isExpired ? "cursor-not-allowed opacity-70" : ""
            }`}
            onClick={() => !isExpired && handleOpen(quizAttempt)}
        >
            <ListItemText
                primary={
                    <>
                        Tentativo del{" "}
                        <TextFormat
                            type="date"
                            value={quizAttempt.createdAt}
                            format={APP_DATE_FORMAT_MID}
                            locale="it"
                        />
                    </>
                }
                secondary={attemptStatus}
            />
        </ListItem>
    );
};

export default UserAttemptRow;
